<c-card *transloco="let t">
    <c-card-body>

            <c-row>
              <c-col md="6">
                  <h1>{{ t('Import Monitors from ADP Workforce Now') }}</h1>
                  <p>{{ t('Please use this page to import users from your ADP Workforce Now account into OK Alone as monitors.') }}</p>
              </c-col>
              <c-col md="6" *ngIf="users">

                <form class="row gy-2 gx-3 align-items-center">
                  <div class="col-auto">
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                      <input cFormControl id="search" name="search" [(ngModel)]="search" placeholder="{{ t('Enter a name') }}" />
                    </div>
                  </div>
                  <div class="col-auto">
                    <button type="submit" class="btn btn-primary my-2 me-2" (click)="doSearch()">{{t('Search')}}</button>
                    <button type="submit" class="btn  btn-light my-2" (click)="cancelSearch()"><i class="fas fa-times"></i></button>
                  </div>
                </form>

                <div *ngIf="okService.settings.adp">
                  <a *ngIf="!okService.settings.adp_ca" class="btn btn-outline-primary" href="https://apps.adp.com/account/users" role="button" target="_new">{{ t('Manage Monitors in ADP Workforce Now') }} <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                  <a *ngIf="okService.settings.adp_ca" class="btn btn-outline-primary" href="https://ca.apps.adp.com/account/users" role="button" target="_new">{{ t('Manage Monitors in ADP Workforce Now') }} <i class="fa-solid fa-arrow-up-right-from-square"></i></a>
                </div>

                <div *ngIf="page>1 || users.length>=100" class="text-end">
                  <div class="btn-group" role="group" aria-label="Basic outlined example">
                    <button type="button" class="btn btn-outline-primary" (click)="prevPage()" *ngIf="page>1"><i class="fa-solid fa-angles-left"></i></button>
                    <button type="button" class="btn btn-outline-primary">Page {{page}}</button>
                    <button type="button" class="btn btn-outline-primary" (click)="nextPage()"><i class="fa-solid fa-angles-right"></i></button>
                  </div>
                </div>
                <br>

              </c-col>
            </c-row>



            <p *ngIf="loading"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Please wait while we load up the monitors, this could take up to 10 seconds.') }}</p>

            <div class="card" *ngIf="show_consent">
              <div class="card-body">
                <div class="alert alert-warning" role="alert">
                  {{ t('We require your consent to access you ADP worker information. Please click the button below:') }}<br/><br/>

                  <a *ngIf="!okService.settings.adp_ca" class="btn btn-success text-white" href="https://adpapps.adp.com/consent-manager/pending/direct?consumerApplicationID=c653b22e-d58b-4804-89bf-a7f215ea2df7&successUri=https://my.okalone.net/mgmt/workers/monitors-adp" role="button">{{ t('Give OK Alone Consent') }}</a>

                  <a *ngIf="okService.settings.adp_ca" class="btn btn-success text-white" href="https://adpapps.adp.com/consent-manager/pending/direct?consumerApplicationID=f7b98dbd-dd97-4f3c-963c-e087c2611d56&successUri=https://my.okalone.net/mgmt/workers/monitors-adp" role="button">{{ t('Give OK Alone Consent') }}</a>
                </div>
              </div>
            </div>

            <c-row *ngIf="!loading && users">
              <c-col>

                <div class="alert alert-info" role="alert" *ngIf="users.length==100">
                  {{ t('We can only show a maximum of 100 monitors here. If you have more please search for their email in the box above or move through the pages.') }}
                </div>


                <table
                [hover]="true"
                [responsive]="true"
                [striped]="true"
                align="middle"
                cTable
                class="mb-0 border"
                >
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">{{ t('Monitor') }}</th>
                      <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of users">
                        <td>
                          <button color="success" cButton class="me-1 btn-sm text-white" *ngIf="user.email && user.is_monitor">
                            <i class="fa-solid fa-eye"></i>
                            {{ t('Imported') }}
                          </button>
                          <button  cButton class="me-1 btn-sm text-white text-white btn-info" (click)="importMonitor(user)" *ngIf="user.email && !user.is_monitor">
                            <i class="fa-solid fa-file-import"></i>
                            {{ t('Import') }}
                          </button>
                          <button color="warning" cButton class="me-1 btn-sm text-white" *ngIf="!user.email">
                            <i class="fa-solid fa-times"></i>
                            {{ t('No Email') }}
                          </button>
                        </td>
                        <td>
                          <span><b>{{user.name}}</b></span>
                        </td>
                        <td>
                          {{user.email}}
                          <div class="small text-medium-emphasis">
                            <span>{{user.phone}}</span>
                          </div>
                        </td>
                        <td>

                      </tr>
                    </tbody>

                </table>

              </c-col>
            </c-row>

    </c-card-body>
  </c-card>
